import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {  map } from 'rxjs/operators';
import { 
  Country,
  Civility,
  ApeCod,
  Currency,
  ExtUserStatut, 
  SupplierStatut,
  LegalForm,
  PS_Lib_Report_Et_Form_Result, 
  Question , 
  Family , 
  PafSetting , 
  Department,
  WFMotif,
  PS_Get_Buttons_Result,
  Profil, 
  DocumentStatut,
  IntUserStatut,
  IntUserPerimeters_XRP,
  ApiVersion,
  RseQuestion,
  RseQuestionsGroup,
  PafDocument,
  DocTyp
} from '../all-models';
import { ENV } from '../env.token';
import { Environment } from '../Environment';
import { HttpClientCached } from '../all-interceptors';

@Injectable({
  providedIn: 'root'
})
export class PafListsService {

  listUrl: string ;
  docsUrl: string;
  constructor( 
    private http: HttpClient, 
    @Inject(ENV) public pafEnvironment: Environment,
    private httpClientCached: HttpClientCached) { 
      this.listUrl = `${pafEnvironment.apiBaseUrl}Lists/`;
      this.docsUrl = `${pafEnvironment.apiBaseUrl}Documents/` ;
    }

  getCountries(): Observable<Country[]> {
    return this.httpClientCached.getCached<Country[]>(this.listUrl + 'countries')
    .pipe(map((items:Country[])=> items.filter(item=> item.Active==1)));
  }
  getCivilities(): Observable<Civility[]> {
    return this.httpClientCached.getCached<Civility[]>(this.listUrl + 'civilities');
  }
  getApeCods(): Observable<ApeCod[]> {
    return this.httpClientCached.getCached<ApeCod[]>(this.listUrl + 'apecods');
  }
  getCurrencies(): Observable<Currency[]> {
    return this.httpClientCached.getCached<Currency[]>(this.listUrl + 'currencies');
  }
  getExtUserStatuts(): Observable<ExtUserStatut[]> {
    return this.httpClientCached.getCached<ExtUserStatut[]>(this.listUrl + 'extuserstatuts');
  }
  getLegalForms(): Observable<LegalForm[]> {
    return this.httpClientCached.getCached<LegalForm[]>(this.listUrl + 'legalforms');
  }
  getCountryLegalForms(countryId: number): Observable<LegalForm[]> {
    return this.httpClientCached.getCached<LegalForm[]>(`${this.listUrl}countries/${countryId}/legalforms`);
  }
  getSupplierStatuts(): Observable<SupplierStatut[]> {
    let ret : Observable<SupplierStatut[]>  = this.httpClientCached.getCached<SupplierStatut[]>(this.listUrl + 'supplierstatuts');
    return ret;
  }
  getResCodLabels(lngCod:string, resCod:string): Observable<PS_Lib_Report_Et_Form_Result[]>{
    if ((resCod||'')=='') resCod='COMMON';
    return this.httpClientCached.getCached<PS_Lib_Report_Et_Form_Result[]>(`${this.listUrl}Labels/${lngCod}/${resCod}`);
  }

  getFamilies(): Observable<Family[]>{
    return this.httpClientCached.getCached<Family[]>(`${this.listUrl}Families`);
  }
  getQuestions(): Observable<Question[]>{
    return this.httpClientCached.getCached<Question[]>(`${this.listUrl}Questions`);
  }

  getDepartments(): Observable<Department[]>{
    return this.httpClientCached.getCached<Department[]>(`${this.listUrl}Departments`);
  }
  getRegions(): Observable<Department[]>{
    return this.httpClientCached.getCached<Department[]>(`${this.listUrl}Regions`);
  }
  getRegionDepartments(dptId:number): Observable<Department[]>{
    return this.httpClientCached.getCached<Department[]>(`${this.listUrl}Regions/${dptId}`);
  }
  
  getWFMotifs(): Observable<WFMotif[]>{
    return this.httpClientCached.getCached<WFMotif[]>(`${this.listUrl}WFMotifs`);
  }
  
  getProfils(): Observable<Profil[]>{
    return this.httpClientCached.getCached<Profil[]>(`${this.listUrl}Profils`);
  }
  
  getDocumentStatuts(): Observable<DocumentStatut[]> {
    return this.httpClientCached.getCached<DocumentStatut[]>(`${this.listUrl}DocumentStatuts`);
  }
  

  getIntUsersStatuts(): Observable<IntUserStatut[]> {
    return this.httpClientCached.getCached<IntUserStatut[]>(`${this.listUrl}IntUserStatuts`);
  }

  getIntUserPerimeters(): Observable<IntUserPerimeters_XRP[]> {
    return this.httpClientCached.getCached<IntUserPerimeters_XRP[]>(`${this.listUrl}IntUserPerimeters`);
  }

  PostButtonMotifs(button:PS_Get_Buttons_Result ) : Observable<WFMotif[]>{
    return this.http.post<WFMotif[]>(`${this.listUrl}ButtonMotifs`,button)
  }

  
  public familyLevel(familyId: number, families:Family[]): number {
    let family: Family = families.find(f => f.Id == familyId);
    if (!family || family.ParentId == null) {
      return 0;
    } else {
      return 1 + this.familyLevel(family.ParentId,families);
    }
  }

  public familyLabel(familyId: number, families:Family[],addhierarchy: boolean = false): string {
    let family: Family = families.find(f => f.Id == familyId);
    if (!family) return '';
    switch (this.familyLevel(familyId,families)) {
      case 1: {
        if (!addhierarchy){
          return family.FamilyCod;
        } else {
          return this.familyLabel(family.ParentId,families,true) +' / '+ family.FamilyCod;
        }
        break;
      }
      case 2: {
        if (!addhierarchy){
          return family.SubFamilyCod;
        } else {
          return this.familyLabel(family.ParentId,families,true) +' / '+ family.SubFamilyCod;
        }
        break;
      }
      default:
        return family.Segment;
        break;
    }
  }

  

  public familyClass(familyId: number, families:Family[], selected : boolean = false): any {
    if (!selected) {
    return {
      //"bg-primary text-white mw-100 mb-2": this.familyLevel(familyId,families) == 0,
      "node-family-0": this.familyLevel(familyId,families) == 0,
      "text-primary small": this.familyLevel(familyId,families) == 1,
      "text-secondary small": this.familyLevel(familyId,families) == 2
    };
    } else {
      return "selected-family";      
    }
  }
  
  public familyIcon(familyId: number, families:Family[]) : any {
    return {
      "k-i-wrench": this.familyLevel(familyId,families) == 0,
      "k-i-cogs": this.familyLevel(familyId,families) == 1,
      "k-i-cog": this.familyLevel(familyId,families) == 2,
      "k-icon": true,
    };
  }
  
  public familyIconClass(familyId: number, families:Family[]) : any {
    return {
      "text-primary small": this.familyLevel(familyId,families) != 2,
      "text-secondary small": this.familyLevel(familyId,families) == 2
    };    
  }

  
  public getRseQuestions(): Observable<RseQuestion[]> {
    return this.httpClientCached.getCached<RseQuestion[]>(`${this.listUrl}RseQuestions`)
    .pipe(map((results:RseQuestion[])=>{
      results.sortObject('DisplayRank');
      return results;
    }));
  }

  public getRseQuestionsGroups(): Observable<RseQuestionsGroup[]> {
    return this.httpClientCached.getCached<RseQuestionsGroup[]>(`${this.listUrl}RseQuestionsGroups`);
  }

  getPafDocuments(): Observable<PafDocument[]> {
    return this.httpClientCached.getCached<PafDocument[]>(`${this.listUrl}PafDocuments`);
  }
  
  getDocTyps(): Observable<DocTyp[]> {
    return this.httpClientCached.getCached<DocTyp[]>(`${this.listUrl}DocTyps`);
  }

  
  getPafSettings(): Observable<PafSetting[]>{
    return this.http.get<PafSetting[]>(`${this.listUrl}PafSettings`);
  }


  public getApiVersion():Observable<ApiVersion>{
    return this.http.get<ApiVersion>(`${this.listUrl}ApiVersion`);
  }

  
  clearServerCache(isAdmin: boolean): Observable<void> {
    this.httpClientCached.clearCache();
    if (!isAdmin){
      return of(void 0);
    }
    return this.http.post<void>(`${this.listUrl}ClearCache`,null);
  }

}
